<template>
  <section id="contactForm" class="relative block py-24 lg:pt-0 bg-gray-900">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center lg:-mt-64 -mt-48">
        <div class="w-full lg:w-6/12 px-4">
          <div
            class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300"
          >
            <div v-if="!hasSendContactForm && !isSending" class="flex-auto p-5 lg:p-10">
              <h4 class="text-2xl font-semibold">Möchten Sie mit uns Kontakt treten?</h4>
              <p
                class="leading-relaxed mt-1 mb-4 text-gray-600"
              >Füllen Sie unser Kontaktformular aus und wir nehmen innert 24 Stunden mit Ihnen Kontakt auf.</p>
              <div class="relative w-full mb-3 mt-8">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  for="name"
                >Ihr Name</label>
                <input
                  id="name"
                  v-model="name"
                  type="text"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full border-white"
                  :class="(!$v.name.required && $v.name.$dirty)? 'bg-red-400' : ''"
                  placeholder="Ihr Name"
                  style="transition: all 0.15s ease 0s;"
                  :on-blur="() => {
                    console.log($v.name.$required)
                    $v.name.$touch();
                    }"
                />
              </div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  for="email"
                >Ihre Email</label>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
                  :class="((!$v.email.required || !$v.email.email) && $v.email.$dirty)? 'bg-red-400' : ''"
                  placeholder="Ihre Email"
                  style="transition: all 0.15s ease 0s;"
                />
              </div>
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  for="message"
                >Ihre Anfrage</label>
                <textarea
                  id="message"
                  v-model="message"
                  rows="4"
                  cols="80"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
                  :class="(!$v.message.required && $v.message.$dirty)? 'bg-red-400' : ''"
                  placeholder="Ihre Anfrage"
                ></textarea>
              </div>
              <div class="text-center mt-6">
                <button
                  class="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                  type="button"
                  style="transition: all 0.15s ease 0s;"
                  @click="() => submitForm(email, name, message)"
                >Anfrage senden</button>
              </div>
            </div>
            <div v-if="isSending" class="flex-auto p-5 lg:p-10 text-center">
              <h4 class="text-2xl font-semibold">Ihre Anfrage wird verarbeitet...</h4>
            </div>
            <div v-if="hasSendContactForm" class="flex-auto p-5 lg:p-10">
              <h4 class="text-2xl font-semibold">Besten Dank für Ihre Kontaktaufnahme.</h4>
              <p
                class="leading-relaxed mt-1 mb-4 text-gray-600"
              >Gerne bearbeiten wir Ihre Anfrage und nehmen mit Ihnen Kontakt auf.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import store from "../store/index.js";

export default {
  data() {
    return {
      name: "",
      email: "",
      message: ""
    };
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    message: {
      required
    }
  },
  methods: {
    submitForm: function(email, name, message) {
      this.$v.$touch();      
      if (!this.$v.$invalid) {
        store.commit("setIsSending", true);
        var payload = {
          email: email,
          name: name,
          message: message
        };
        store.dispatch("sendConcatForm", payload).catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      }
    }
  },
  computed: {
    hasSendContactForm: function() {
      return store.state.hasSendContactForm;
    },
    isSending: function() {
      return store.state.isSending;
    }
  }
};
</script>

<style>
</style>